<template>
  <div class="page-main">
    <e-tabs :list="this.$constant.tabListPurchase()" isJump />
    <!-- 表格操作条 -->
    <vxe-toolbar ref="refToolbar" size="mini" :loading="loading">
      <template #buttons>
        <el-button type="primary" size="mini" @click="generateInquiry">生成询价单</el-button>
        <el-button type="primary" size="mini" @click="generatePurchase">生成采购订单</el-button>
        <el-button type="primary" size="mini" @click="generateSelfProcess">
          生成本厂加工单
        </el-button>
        <el-button type="danger" size="mini" @click="itemDelete">删除</el-button>
      </template>
    </vxe-toolbar>

    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      show-footer
      :loading="loading"
      :columns="tableColumn"
      :data="tableData"
      :height="this.$util.getViewHeight() - 187"
      :export-config="{ type: ['xlsx'], types: ['xlsx'] }"
      :keyboard-config="{ isArrow: true }"
      :footer-method="footerMethod"
      :merge-cells="mergeCell"
      @keydown="tableKeydown"
      @current-change="tableCurrentChange"
    >
      <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          @change="headerFilterChange"
        />
      </template>
      <template #header_daterange="{ column }">
        <c-table-header
          type="daterange"
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :value.sync="filterData.shen_gou_bill_date"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <template #default_shen_gou_bill_date="{ row }">
        {{ row.shen_gou_bill_date ? row.shen_gou_bill_date.slice(0, 10) : '' }}
      </template>
      <template #default_shen_gou_code="{ row }">
        <div>
          <el-link type="primary" @click="itemApplyDetail(row)"> {{ row.shen_gou_code }} </el-link>
        </div>
        <div>
          <el-link type="primary" @click="itemCheckAll(row)"> 全选当前单号 </el-link>
        </div>
      </template>
      <template #default_bill_code="{ row }">
        <el-link type="primary" @click="itemSaleDetail(row)"> {{ row.bill_code }} </el-link>
      </template>
      <template #default_cai_gou_stock_counts_list="{ row }">
        {{ row.cai_gou_stock_counts_list.join(',') || 0 }}
      </template>
      <template #default_test_standard="{ row }">
        <el-link type="primary" @click="openPopupTest(row)"> 查看 </el-link>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-生成采购订单 -->
    <PopupGeneratePurchase
      v-if="isShowPopupGeneratePurchase"
      :show.sync="isShowPopupGeneratePurchase"
      :list="activeList"
      @success="searchListData"
    />

    <!-- 弹窗-生成本厂加工单 -->
    <PopupGenerateSelfProcess
      v-if="isShowPopupGenerateSelfProcess"
      :show.sync="isShowPopupGenerateSelfProcess"
      :list="activeList"
      @success="searchListData"
    />

    <!-- 弹窗-检测标准 -->
    <b-popup-test v-if="isShowPopupTest" :show.sync="isShowPopupTest" :data="activeObj" />
  </div>
</template>

<script>
export default {
  components: {
    PopupGeneratePurchase: () => import('./popup-generate-purchase'),
    PopupGenerateSelfProcess: () => import('./popup-generate-self-process')
  },
  data() {
    return {
      loading: true,

      // filter
      filterData: {
        shen_gou_bill_date: [this.$util.getDate().monthDay, this.$util.getDate().today]
      },
      sortData: {
        shen_gou_stock_id: 'desc'
      },

      // table
      headerFilterUrl: '/admin/gcvip/shengou/searchHeard',
      mergeCell: [],
      tableData: [],
      tableColumn: [
        {
          fixed: 'left',
          type: 'checkbox',
          width: 40
        },
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '采购申请日期',
          field: 'shen_gou_bill_date',
          width: 180,
          isMerge: true,
          slots: { header: 'header_daterange', default: 'default_shen_gou_bill_date' }
        },
        {
          title: '采购申请单号',
          field: 'shen_gou_code',
          width: 110,
          isMerge: true,
          slots: { header: 'header_input', default: 'default_shen_gou_code' }
        },
        {
          title: '销售单号',
          field: 'bill_code',
          width: 90,
          isMerge: true,
          slots: { header: 'header_input', default: 'default_bill_code' }
        },
        {
          title: '建议供应商',
          field: 'jian_yi_supplier_name',
          slots: { header: 'header_input' }
        },
        {
          title: '业务员',
          field: 'saler_name',
          isMerge: true,
          slots: { header: 'header_input' }
        },
        {
          title: '商品类型',
          field: 'type_name',
          slots: { header: 'header_input' }
        },
        {
          title: '品名',
          field: 'craft',
          slots: { header: 'header_input' }
        },
        {
          title: '工艺',
          field: 'process_name',
          slots: { header: 'header_input' }
        },
        {
          title: '材质',
          field: 'texture',
          slots: { header: 'header_input' }
        },
        {
          title: '规格',
          field: 'specification',
          width: 120,
          slots: { header: 'header_input' }
        },
        {
          title: '单位',
          field: 'unit',
          slots: { header: 'header_input' }
        },
        {
          title: '申购数量',
          field: 'shen_gou_stock_counts',
          slots: { header: 'header_input' }
        },
        {
          title: '已采购数量',
          slots: { default: 'default_cai_gou_stock_counts_list' }
        },
        {
          title: '单价(元)',
          field: 'shen_gou_stock_price',
          slots: { header: 'header_input' }
        },
        {
          title: '成本金额(元)',
          field: 'shen_gou_stock_amount',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          title: '检测标准',
          field: 'test_standard',
          slots: { header: 'header_input', default: 'default_test_standard' }
        }
      ],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        sales_amount_all: ''
      },

      isShowPopupGeneratePurchase: false, // 是否显示生成采购订单弹窗
      isShowPopupGenerateSelfProcess: false, // 是否显示生成本厂加工单弹窗
      isShowPopupTest: false, // 是否显示产品工艺管控卡弹窗
      activeList: [],
      activeObj: ''
    }
  },
  mounted() {
    this.getListData()
    this.$nextTick(() => {
      this.$refs.refTable.connect(this.$refs.refToolbar) // 手动将表格和工具栏进行关联
    })
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/shengou/list',
        data: {
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          filterData: this.filterData,
          sortData: this.sortData
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            this.tableData = data.list
            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber
            this.totalObj.sales_amount_all = res.data.sales_amount_all
            this.mergeCell = this.$tool.getMergeCellConfigList(
              this.tableData,
              this.tableColumn,
              'shen_gou_code'
            )
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 表格底部
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (column.field === 'shen_gou_stock_amount') return this.totalObj.sales_amount_all
        })
      ]
    },
    // 获取-当前单选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true) // 选中checkbox
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 项-申购详情
    itemApplyDetail(row) {
      window.open(`/purchase/apply/print-apply?code=${row.shen_gou_code}`, '_blank')
    },
    // 项-全选当前单号
    itemCheckAll(row) {
      let rows = this.tableData.filter((item) => item.shen_gou_code === row.shen_gou_code)
      this.$refs.refTable.setCheckboxRow(rows, true)
    },
    // 项-销售详情
    itemSaleDetail(row) {
      window.open(`/sale/verify/detail?id=${row.bill_id}`, '_blank')
    },
    // 生成询价单
    generateInquiry() {
      let rows = this.getCheckboxRecords()
      if (rows.length) {
        // 生成询价单-执行
        let ids = rows.map((item) => item.shen_gou_stock_id).join(',')
        window.open(`/purchase/apply/print-inquiry?ids=${ids}`, '_blank')
      } else {
        this.itemChoosePrompt()
      }
    },
    // 生成采购单
    generatePurchase() {
      let rows = this.getCheckboxRecords()
      if (rows.length) {
        this.generatePurchaseAction(rows)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 生成采购单-执行
    generatePurchaseAction(rows) {
      this.isShowPopupGeneratePurchase = true
      this.activeList = this.$util.deepCopy(rows)
    },
    // 生成采购单
    generateSelfProcess() {
      let rows = this.getCheckboxRecords()
      if (rows.length) {
        this.generateSelfProcessAction(rows)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 生成采购单-执行
    generateSelfProcessAction(rows) {
      this.isShowPopupGenerateSelfProcess = true
      this.activeList = this.$util.deepCopy(rows)
    },
    // 项-删除
    itemDelete() {
      let rows = this.getCheckboxRecords()
      if (rows.length) {
        this.itemDeleteAction(rows)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-删除
    itemDeleteAction(rows) {
      let ids = rows.map((item) => item.shen_gou_stock_id).join(',')
      this.$confirm(`采购申请单id：${ids}，是否批量删除选中申请单?`, '提示')
        .then(() => {
          this.itemDeleteConfirm(ids)
        })
        .catch(() => {})
    },
    // 项-删除-确认
    itemDeleteConfirm(ids) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/shengou/delete',
        params: {
          shen_gou_stock_id: ids
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('删除成功')
          this.getListData()
        }
      })
    },
    // 检测标准
    openPopupTest(row) {
      this.activeObj = row
      this.isShowPopupTest = true
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
